import { render, staticRenderFns } from "./ShortcutKeys.vue?vue&type=template&id=8df8dffe&scoped=true"
import script from "./ShortcutKeys.vue?vue&type=script&lang=js"
export * from "./ShortcutKeys.vue?vue&type=script&lang=js"
import style0 from "./ShortcutKeys.vue?vue&type=style&index=0&id=8df8dffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df8dffe",
  null
  
)

export default component.exports